// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","container":"styles_container__Fi_AL","closeButton":"styles_closeButton__86SL3","closeIcon":"styles_closeIcon__Qxinm"};